export enum WishlistErrors {
    CustomerNotFound = 'customerNotFound',
    Default = 'defaultError',
}
